import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import VehiculosListComponent from './Vehiculos/VehiculosListComponent';

function PanelVehiculos(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <VehiculosListComponent></VehiculosListComponent>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelVehiculos)
